export function shouldAdvanceToNextDocument(key: string): boolean {
  return key === 't' || key === 'f' || key === 'w'
}

export function parseTierShortcutKey(key: string): 1 | 2 | 3 | null {
  if (key === '1') {
    return 1
  }
  if (key === '2') {
    return 2
  }
  if (key === '3') {
    return 3
  }
  return null
}

export function isOpenTagMenuShortcut(event: Pick<KeyboardEvent, 'ctrlKey' | 'altKey' | 'code'>): boolean {
  return event.ctrlKey && event.altKey && event.code === 'KeyI'
}
